import { Card, CardActionArea, CardContent, Chip, Stack, Typography } from '@mui/material';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { HelpArticle } from './types';

const HelpArticleCard = ({ article, onOpen, compact = false }: {
  article: HelpArticle;
  onOpen: (article: HelpArticle) => void;
  compact?: boolean;
}) => <Card variant="outlined" sx={{ height: '100%' }}>
  <CardActionArea onClick={() => onOpen(article)} sx={{ height: '100%', alignItems: 'stretch' }}>
    <CardContent sx={{ p: compact ? 2 : 2.5 }}>
      <Stack direction="row" spacing={1.25} alignItems="flex-start">
        <ArticleOutlinedIcon color="primary" sx={{ mt: 0.25, flexShrink: 0 }} />
        <Stack spacing={compact ? 0.5 : 1} sx={{ minWidth: 0 }}>
          <Typography variant={compact ? 'subtitle1' : 'h6'} fontWeight={750}>{article.title}</Typography>
          <Typography variant="body2" color="text.secondary">{article.summary}</Typography>
          {!compact && <Chip size="small" variant="outlined" label={article.category} sx={{ alignSelf: 'flex-start' }} />}
        </Stack>
      </Stack>
    </CardContent>
  </CardActionArea>
</Card>;

export default HelpArticleCard;
